<div class="modal-dialog move-folder-dialog-container">
  <div class="modal-content" cdkTrapFocus>
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="common_move-folder"></h4>
      <button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'common_close' | translate">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      <ng-select [items]="orgs$ | async"
        bindLabel="name"
        (change)="orgChanged($event)"
        [clearable]="false"
        [loading]="orgsLoading$ | async"
        [virtualScroll]="true"
        [(ngModel)]="selectedOrg">
        <ng-template ng-label-tmp let-item="item">
          {{ item.name }} ({{item.group_id}})
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ item.name }} ({{item.group_id}})
        </ng-template>
      </ng-select>
      @if (accounts$ | async) {
        <ng-select
          [items]="accounts$ | async"
          bindLabel="name"
          [clearable]="false"
          [loading]="accountsLoading$ | async"
          [(ngModel)]="selectedAccount">
          <ng-template ng-label-tmp let-item="item">
            {{ item.name }} ({{item.group_id}})
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.name }} ({{item.group_id}})
          </ng-template>
        </ng-select>
      }
      @if ((accounts$ | async) == null && selectedOrg) {
        <div class="accounts-loading">
          <i class="ficon-spinner ficon-spin"></i>
          <span translate="modal-move-folder-loading-accounts"></span>
        </div>
      }
    </div>
    <div class="goreact-modal-footer">
      <button class="cancel-button tertiary-btn" (click)="cancel()" translate="common_cancel"></button>
      <button class="confirm-button primary-btn" (click)="confirm()" translate="common_move-folder" [disabled]="!selectedAccount"></button>
    </div>
  </div>
</div>
